import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import "./styles/PopupDownloadSuccessful.css";

const PopupDownloadSuccessful = ({ open, close }) => {
  return (
    <GenericPopup
      open={open}
      className="artwork-options__download-template-container w-[25em] pb-4"
      opacity
    >
      <div className="download-success__header">
        <p className="download-success__title">Ready to be used!</p>
        <p className="download-success__subtitle">
          The template has been successfully downloaded
        </p>
      </div>

      {/* <div className="download-success__preview">{children}</div> */}

      <ContinueButton className="download-success__cta" onClick={close}>
        Close
      </ContinueButton>
    </GenericPopup>
  );
};

export default PopupDownloadSuccessful;
